(function() {
    const doubleOptInBox = document.querySelector('.double-opt-in');
    const doubleOptInConfirmedBox = document.querySelector('.double-opt-in-confirmed');
    const newsletterFormBox = document.querySelector('.newsletter-form');

    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    if(params.doubleOptIn) {
        doubleOptInBox.classList.remove('d-none');
        hideNewsletterBox();
    }

    if(params.doubleOptInConfirmed) {
        doubleOptInConfirmedBox.classList.remove('d-none');
        hideNewsletterBox();
    }

    function hideNewsletterBox() {
        newsletterFormBox.classList.add('d-none');
    }
})();
